import "./module/menuTrigger";

require('./module/common')
require('./module/modaal')
require('./module/movoto-scroll')
// require('./module/loading')
require('./module/loading-onload')
require('./module/counter')
require('./module/gsap-scrollAnimation')
